import { useIdentityKeys } from "@/hooks/useIdentityKeys";

/** Mounts at app root — silently provisions/uploads the user's E2E public key. */
export default function E2EBootstrap() {
  useIdentityKeys();
  return null;
}